<template>
  <vx-card>
    <b-row>
      <b-col lg="2">
        <ButtonPrimary :color="filtrecolor" :size="size" :title="title" @test-click="resetState" />

      </b-col>
    </b-row> 
    <ag-grid-vue style="width: 100%; height: 400px; margin-top: 25px" class="ag-theme-alpine"
      :defaultColDef="defaultColDef" :columnDefs="columnDefs" :rowData="row" :rowSelection="rowSelection"
      :localeText="localeText" @grid-ready="onGridReady" @rowClicked="onSelectionChanged"
      @first-data-rendered="onFirstDataRendered" @filter-changed="onFilterChanged" @filter-modified="onFilterModified">
    </ag-grid-vue>
    <div class="d-flex justify-content-between flex-wrap">
      <div class="d-flex align-items-center mb-0 mt-1">
        <span class="text-nowrap"> Gösterilen kayıt </span>
        <b-form-select v-model="pageLength" :options="['50', '100', '250', '500', '1000']" class="mx-1"
          v-on:change="listele()" />
      </div>
      <div>

      </div>
    </div>
  </vx-card>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import SatinalmaTopContent from "./SatinalmaTopContent.vue";
import Store from "../../../../store/store";
import state from "../../../../store/state";
import ButtonPrimary from "../global-components/ButtonPrimary.vue";

export default {
  name: "tables",
  props: ["gelentur", "column", "row", "kayitsayisi"],
  data() {
    return {
      size: "small",
      title: "Filtrelemeyi Resetle",
      filtrecolor: "success",
      defaultColDef: {
        sortable: true,
        resizable: true,
      },
      rowSelection: null,
      localeText: null,
      columnDefs: [],
      rowData: [],
      turAl: "",
      pageLength: 50,
      currentGelenPage: 1,
      KAYITSAYISI: 0,
      gelenfiltre: "",
    };
  },

  components: {
    ButtonPrimary,
    AgGridVue,
    SatinalmaTopContent,
  },
  methods: {
    resetState() {
      this.gridApi.setFilterModel(null);
      this.gelenfiltre = "";
      this.$parent.satinAlma();
    },
    onFilterChanged(e) {
      if (typeof e.filterInstance == "undefined") console.log("in");
      else {
        var savedFilterModel = e.api.getFilterModel();
        var keys = Object.keys(savedFilterModel);

        if (keys.length > 1) {
          console.log("arama yapma");
        } else {
          const soap = require("soap");
          const url = state.sistemAddress;
          if (this.gelenfiltre == "") {
            //   this.$parent.satinAlma();
          } else {
            this.$root.$emit("topcontent");
            this.$emit("arananfiltre", this.gelenfiltre);
          }
        }
      }
    },
    onFilterModified(e) {
      if (e.filterInstance.getModelFromUi() == null) console.log("in");
      else this.gelenfiltre = e.filterInstance.getModelFromUi().filter;
    },

    scrollToTop() {
      window.scrollTo(0, 0);
    },

    listele() {
      //topcontent metdu çağrılıyor
      this.$root.$emit("topcontent");
      this.$parent.satinAlma();
      this.scrollToTop();
    },

    onSelectionChanged(params) {
      this.$store.commit("account/SATINALMA_TUR", this.tur);
    },
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
  },

  created() {
    this.rowSelection = "single";
    this.turAl = this.gelentur;
    this.KAYITSAYISI = this.kayitsayisi;

    this.rowData = this.row;
    this.localeText = this.$store.state.account.AG_GRID_LOCALE_EN;
  },
  watch: {
    rowLocal(val) {
      console.log(val)
      /*
      var vm = this;
      let columnList = Object.keys(val[0]);

      columnList.forEach((val, index) => {
        if (!val.includes("id"))
          vm.columnDefs.push({
            field: val,
            filter: "agSetColumnFilter",
            cellRenderer: "TextGorunumCellRenderer",
          });
      })*/
      this.columnDefs = this.column
    }
  },
  computed: {
    rowLocal: {
      get() {
        return this.row
      },
      set(val) {
        if (!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
  }
};
</script>